.container {
  display: flex;
  gap: 10px;
  padding: 8px;
  margin: 8px 0;
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-regular);
  line-height: 120%;
  color: var(--gray-700);
  background-color: var(--blue-50);
  border-radius: 8px;

  svg {
    color: var(--blue-700);
  }
}

.text {
  flex: 1;
  margin: 0;
}
